<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 33 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83333 6.27792C4.97222 6.27792 4.23375 5.97 3.61792 5.35417C3.00236 4.73833 2.69458 3.99986 2.69458 3.13875C2.69458 2.27764 3.00236 1.5393 3.61792 0.923749C4.23375 0.307916 4.97222 0 5.83333 0C6.69444 0 7.43292 0.307916 8.04875 0.923749C8.66431 1.5393 8.97208 2.27764 8.97208 3.13875C8.97208 3.99986 8.66431 4.73833 8.04875 5.35417C7.43292 5.97 6.69444 6.27792 5.83333 6.27792ZM3.33333 33.3333V21.6667H0V11.3054C0 10.5371 0.270833 9.88208 0.8125 9.34042C1.35417 8.79875 2.00931 8.52792 2.77792 8.52792H8.88875C9.65736 8.52792 10.3125 8.79875 10.8542 9.34042C11.3958 9.88208 11.6667 10.5371 11.6667 11.3054V15.8054C10.1389 16.7499 8.89583 18.0463 7.9375 19.6946C6.97917 21.3426 6.5 23.1482 6.5 25.1113C6.5 26.3796 6.69903 27.5578 7.09708 28.6458C7.49542 29.7339 8.00014 30.6668 8.61125 31.4446V33.3333H3.33333ZM17.5 33.3333C15.2314 33.3333 13.2939 32.5347 11.6875 30.9375C10.0811 29.3403 9.27792 27.3982 9.27792 25.1113C9.27792 23.3796 9.80792 21.7615 10.8679 20.2571C11.9282 18.7524 13.3982 17.7407 15.2779 17.2221V20.2638C14.2685 20.6713 13.479 21.3333 12.9096 22.25C12.3401 23.1667 12.0554 24.1204 12.0554 25.1113C12.0554 26.6296 12.5832 27.9165 13.6388 28.9721C14.6943 30.0276 15.9814 30.5554 17.5 30.5554C19.0742 30.5554 20.3982 29.9582 21.4721 28.7638C22.5463 27.5693 22.9815 26.1296 22.7779 24.4446H25.5554C25.7963 26.7871 25.1042 28.8542 23.4792 30.6458C21.8542 32.4375 19.8611 33.3333 17.5 33.3333ZM30.3471 29.6667L25.8888 23.0554H16.6667V10.2779H19.4446V20.2779H27.4446L32.6667 28.1388L30.3471 29.6667Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#3E3B39",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
